<style>

.v-label {
  font-size:18px;
  height: 25px !important;
}

.v-select__slot, .v-text-field__slot {
  padding-top: 5px;
}

.v-select__selection {
  line-height: 20px;
}

.v-input--selection-controls {
  margin-top: 0;
}

@font-face {
  font-family: "Bliss 2";
  src: url(./fonts/Bliss2/Bliss2R.otf) format("opentype");
}

@font-face {
  font-family: "Bliss 2";
  font-weight: bold;
  src: url(./fonts/Bliss2/Bliss2B.otf) format("opentype");
}

body,
.v-application {
  font-family: "Bliss 2", Helvetica, Arial;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  font-family: "Bliss 2", Helvetica, Arial;
  font-weight: bold;
}

.v-application a[disabled] {
  cursor: default;
}

.v-application a.page-header-title {
  color: white; 
  user-select: none;
}

.v-application button.primary:not([disabled]):hover {
  background-color: #FFF !important;
  color: #DB4132 !important;
  border: 1px solid #DB4132;
  transition: .2s;
}

.hasValidationErrorIcon .v-input__prepend-inner {
  display: none !important;
}

.hasValidationErrorIcon.error--text .v-input__prepend-inner {
  display: inline-block !important;
}

.hasValidationErrorIcon.error--text .v-label {
  left: -25px !important;
}

</style>

<template>
  <v-app>
    <v-app-bar app color="primary" dark>
      <v-toolbar-title>
        <a class="page-header-title" v-on="navigateToPageClickHandler" :disabled="disableHeaderNavigation">
          <h2 class="page-header-text">{{ pageHeaderTitle }}</h2>
        </a>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon :disabled="disableHeaderNavigation">
        <v-img src="./assets/logo.png" width="50" height="50" contain v-on="navigateToPageClickHandler"></v-img>
      </v-btn>
    </v-app-bar>
    <v-main>
      <v-container class="px-4 py-0 fill-height" fluid>
        <v-row class="fill-height">
          <v-col>
            <transition name="fade">
              <router-view></router-view>
            </transition>
          </v-col>
        </v-row>
      </v-container>
      <v-footer color="primary" class="py-3">
        <span class="overline white--text">&copy; {{ year }} MaltaPost |
          <span v-if="!isMobile()">All rights reserved | </span>Version
          {{ version }}
        </span>
      </v-footer>
    </v-main>
    <v-overlay :value="busy">
      <v-progress-circular indeterminate size="64">{{uploadProgress?uploadProgress+'%':''}}</v-progress-circular>
    </v-overlay>
  </v-app>
</template>

<script>
import properties from "./assets/properties.json";
import router from './router'
import { createNamespacedHelpers } from "vuex";

const { mapGetters } = createNamespacedHelpers("missedDelivery");

export default {
  name: "App",

  components: {},

  data: () => ({
    sidebarMenu: false,
    pageHeaderTitle: '',
    year: new Date().getFullYear(),
    navigateToPageClickHandler: {},
    disableHeaderNavigation: false,
    version: properties.ServiceComponentVersion
  }),
  computed: {
    ...mapGetters(["busy", "uploadProgress"]) 
  },
  methods: {
    isMobile() {
      if (window.innerWidth <= 800) {
        return true;
      } else {
        return false;
      }
    },
    updatePageHeaderTitle(route) {
      this.pageHeaderTitle = route.meta.pageHeaderTitle || '';
    },
    setNavigateToPageClickHandler(route) {
      const pageHeaderRedirectionPath = 
        route.meta.pageHeaderRedirectionPath;

      this.disableHeaderNavigation = !pageHeaderRedirectionPath;

      this.navigateToPageClickHandler = this.disableHeaderNavigation ? 
        {} : { click: () => this.handleNavigateToPageClick(pageHeaderRedirectionPath) };
    },
    handleNavigateToPageClick(pageHeaderRedirectionPath) {
      router.push(pageHeaderRedirectionPath).catch(() => {}); // Catch to avoid error message in console (see MissedDelivery.vue -> beforeRouteLeave)
    }
  },
  created: function () {
    this.sidebarMenu = !this.isMobile();

    this.updatePageHeaderTitle(this.$route);
    this.setNavigateToPageClickHandler(this.$route);
  },
  watch: {
    '$route'(to) {
      this.updatePageHeaderTitle(to);
      this.setNavigateToPageClickHandler(to);
    }
  }
};
</script>

<style scoped>
@media screen and (max-width: 699px) {

  .page-header-text {
    font-size: 16px;
   }
}  
</style>